<app-material-position-table #positionTable
                             [material]="material"
                             [partnerCode]="partnerCode"
                             [claimCodeCode]="claimCode"
                             [supplyingPackingPlantCode]="supplyingPackingPlantCode"
                             [enableTableLoading]="true"
                             [maxNumberOfPositions]="maxNumberOfPositions"
                             [editMode]="true"></app-material-position-table>
